// Add verified client work here. Empty collections are not rendered.
export const projects: { id: string; name: string; description: string; image: string; url: string; published: boolean }[] = [];